export default __webpack_public_path__ + "static/media/step1.f6688427.png";